<app-customer-search [resourceType]="'CustomersWithoutCondition'">
</app-customer-search>
